import React, { useCallback } from 'react';
import { Button } from '@mui/material';

import LogOperationHistoryApi from '../../../../../../../api/patient/LogOperationHistoryApi';
import modalBoxes from '../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import { scDarkBlue100 } from '../../../../../../../constants/systemColors';
import { ROLE_CRA } from '../../../../../../../constants/userRoles';
import { userHasRole } from '../../../../../../../services/auth';
import { onRequestError } from '../../../../../../../services/handlers';
import { generateUrlByKey } from '../../../../../../root/router';
import { LinkedParticipantsModal } from '../../../../shared/Review/ReviewContent/LogItemGroupElement/LogItemGroupContent/LinkedParticipantsButton/LinkParticipantsModal/LinkedParticipantsModal';

export const ParticipantsButton = ({ statusHistoryId, participantsCount, linked }) => {
  const generateUrlToPatientInfoPage = useCallback(
    row =>
      generateUrlByKey('Patients.Patient Profile.Patient Studies', {
        patientId: row.patientUniqueId,
        ssuPatientId: row.ssuPatientId
      }),
    []
  );
  const onButtonClick = useCallback(() => {
    LogOperationHistoryApi.getLogOperationHistoryParticipants(statusHistoryId).then(({ data }) => {
      modalBoxes.open({
        title: linked ? 'Linked Subjects' : 'Unlinked Subjects',
        component: (
          <LinkedParticipantsModal
            participants={data}
            showPatientColumn={!userHasRole(ROLE_CRA)}
            generateUrlToPatientInfoPage={generateUrlToPatientInfoPage}
          />
        ),
        className: 'linked-participants-modal',
        size: 'w1100'
      });
    }, onRequestError);
  }, [generateUrlToPatientInfoPage, linked, statusHistoryId]);

  return (
    <Button
      onClick={onButtonClick}
      type="text"
      sx={{
        color: scDarkBlue100,
        minWidth: 'fit-content',
        padding: '0 5px',
        textTransform: 'none'
      }}
      data-testid="participants-button"
    >
      {participantsCount} subject(s)
    </Button>
  );
};
